import { useEffect } from 'react'
import { Link } from 'react-router-dom'

const TERMLY_SCRIPT_ID = 'termly-jssdk'
const TERMLY_SCRIPT_SRC = 'https://app.termly.io/embed-policy.min.js'
const TERMLY_POLICY_ID = '7d55da29-c2d0-4d48-ac26-b2dd2135694e'

/**
 * Cookie policy page rendered inside the React application shell.
 *
 * The policy body is sourced from Termly; the surrounding card provides
 * Vault-specific support context that complements the embedded document.
 *
 * @returns JSX.Element The cookie policy page
 */
function CookiePolicyPage() {
  // Re-inject the Termly loader on every mount. The vendor snippet bails when
  // its script tag is already present, so on SPA back-navigation the embed
  // would otherwise stay blank.
  useEffect(() => {
    document.getElementById(TERMLY_SCRIPT_ID)?.remove()
    const script = document.createElement('script')
    script.id = TERMLY_SCRIPT_ID
    script.src = TERMLY_SCRIPT_SRC
    script.async = true
    document.body.appendChild(script)
    return () => {
      script.remove()
    }
  }, [])

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <p className="legal-kicker">Vault Financial</p>
        <h1>Cookie Policy</h1>
        <p className="legal-subtitle">
          How Vault Financial uses cookies and similar technologies across the web experience.
        </p>
      </div>

      <div
        className="legal-termly-embed"
        dangerouslySetInnerHTML={{
          __html: `<div name="termly-embed" data-id="${TERMLY_POLICY_ID}"></div>`,
        }}
      />

      <div className="legal-grid">
        <section className="legal-card">
          <h2>Questions about cookies?</h2>
          <p>
            For cookie or tracking questions, contact{' '}
            <a href="mailto:support@vaultfinance.ai">support@vaultfinance.ai</a>.
          </p>
        </section>
      </div>

      <div className="legal-actions">
        <Link to="/" className="btn btn-primary">
          Return Home
        </Link>
        <Link to="/privacy" className="btn btn-secondary">
          Review Privacy Policy
        </Link>
      </div>
    </div>
  )
}

export default CookiePolicyPage
